import { create } from 'zustand';
import { persist } from 'zustand/middleware';

// ── Theme (dark / light) ─────────────────────────────────────────
export const useThemeStore = create(
  persist(
    (set) => ({
      theme: 'light',
      setTheme: (theme) => {
        set({ theme });
        applyTheme(theme);
      },
      toggleTheme: () =>
        set((s) => {
          const next = s.theme === 'dark' ? 'light' : 'dark';
          applyTheme(next);
          return { theme: next };
        }),
    }),
    { name: 'sparknation-theme' },
  ),
);

export function applyTheme(theme) {
  const root = document.documentElement;
  if (theme === 'dark') {
    root.classList.add('dark');
  } else {
    root.classList.remove('dark');
  }
}

// ── Language ─────────────────────────────────────────────────────
export const LANGUAGES = [
  { code: 'en',    label: 'English',              flag: '🇺🇸' },
  { code: 'es',    label: 'Español',              flag: '🇪🇸' },
  { code: 'fr',    label: 'Français',             flag: '🇫🇷' },
  { code: 'de',    label: 'Deutsch',              flag: '🇩🇪' },
  { code: 'pt',    label: 'Português',            flag: '🇧🇷' },
  { code: 'ar',    label: 'العربية',              flag: '🇸🇦' },
  { code: 'zh',    label: '中文 (简体)',           flag: '🇨🇳' },
  { code: 'hi',    label: 'हिन्दी',               flag: '🇮🇳' },
  { code: 'ja',    label: '日本語',               flag: '🇯🇵' },
  { code: 'ko',    label: '한국어',               flag: '🇰🇷' },
  { code: 'ru',    label: 'Русский',              flag: '🇷🇺' },
  { code: 'vi',    label: 'Tiếng Việt',           flag: '🇻🇳' },
  { code: 'tl',    label: 'Filipino',             flag: '🇵🇭' },
  { code: 'so',    label: 'Soomaali',             flag: '🇸🇴' },
  { code: 'sw',    label: 'Kiswahili',            flag: '🇰🇪' },
];

export const useLangStore = create(
  persist(
    (set) => ({
      lang: 'en',
      setLang: (lang) => set({ lang }),
    }),
    { name: 'sparknation-lang' },
  ),
);
